// Returns the Rails CSRF token as an axios header hash for mutating (POST/PATCH/
// DELETE) requests; GET requests don't need it. ApplicationController runs
// `protect_from_forgery with: :exception`, so a mutating request without this
// header is rejected outright — the parent-facing logout and the admin
// components both rely on it. Returns an empty object when the meta tag is
// absent so callers can always spread it into headers.
export const csrfHeaders = (): Record<string, string> => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  const token = meta ? meta.getAttribute('content') : null;

  return token ? { 'X-CSRF-Token': token } : {};
};

export default csrfHeaders;
